import React from "react";
import "./Nav.css";
import img from '../../image/logo.png'

const Nav = () => {
    return (
        <div className="nav-container">
            <img src={img} alt="" />
        </div>
    );
};

export default Nav;

